import { motion } from "framer-motion";

// Misteck brand glyph — the yellow "M + Play" tile as a crisp inline SVG so the
// central play-triangle notch can animate. `pulse` gently throbs the play notch
// (used on the app loading screen); otherwise it renders as a static mark.
export default function MisteckMark({ size = 96, pulse = false, rounded = true, className = "", glow = false }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      className={className}
      role="img"
      aria-label="Misteck"
      style={glow ? { filter: "drop-shadow(0 10px 34px rgba(255,208,40,0.35))" } : undefined}
    >
      {rounded && <rect x="2" y="2" width="116" height="116" rx="30" fill="#FFD028" />}
      {/* Bold M — two uprights + centre peak */}
      <path
        d="M29 92 L29 34 L60 64 L91 34 L91 92"
        fill="none"
        stroke="#141414"
        strokeWidth="12.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      {/* Central play-triangle notch — the animated element */}
      <motion.path
        d="M50 50 L50 84 L79 67 Z"
        fill="#141414"
        style={{ transformBox: "fill-box", transformOrigin: "center" }}
        initial={false}
        animate={pulse ? { scale: [1, 1.16, 1], opacity: [1, 0.8, 1] } : { scale: 1, opacity: 1 }}
        transition={pulse ? { duration: 1.15, repeat: Infinity, repeatDelay: 0.45, ease: "easeInOut" } : { duration: 0 }}
      />
    </svg>
  );
}
